export default "__VITE_ASSET__B7pKFOz5__"